<template>
  <nx-auth-card
    :title="$t('message.login.forgotPassword.' + (submitted?'checkYourEmail':'title'))"
    v-on="$listeners"
  >
    <template v-if="submitted">
      <ds-text>
        {{ $t('message.login.forgotPassword.submitted') }}
      </ds-text>
      <p
        v-if="loading"
        class="mb-0 text-xs-center"
      >
        <v-progress-circular
          color="grey"
          indeterminate
          size="28"
          width="2"
        />
      </p>
      <template v-else>
        <ds-text
          v-if="emailAlreadySent"
          v-text="$t('message.login.forgotPassword.emailAlreadySent')"
        />
        <ds-text
          v-else-if="emailSentAgain"
          v-text="$t('message.login.forgotPassword.emailSentAgain')"
        />
        <ds-text>
          {{ $t('message.login.forgotPassword.didntReceiveEmail') }}
          <a
            @click="submit"
            v-text="$t('message.login.forgotPassword.resendEmail')"
          />
        </ds-text>
      </template>
    </template>

    <template v-else>
      <nx-form
        @form="form = $event"
        @submit.prevent="submit"
      >
        <ds-text>
          {{ $t('message.login.forgotPassword.description') }}
        </ds-text>
        <nx-form-text
          v-model="email"
          :autofocus="!email"
          :label="$t('message.form.fields.email')"
          append-icon="email"
          name="email"
          validation="required|email"
          @keyup.enter.native="submit"
        />
        <v-btn
          v-if="!submitted"
          :disabled="form.invalid || form.pristine"
          :loading="loading"
          block
          color="secondary"
          @click="submit"
        >
          {{ $t('message.login.forgotPassword.sendEmail') }}
        </v-btn>
        <ds-text>
          {{ $t('message.login.forgotPassword.didRememberPassword') }}
          <a @click.prevent="goToLoginPage">
            {{ $t('message.login.login') }}
          </a>
        </ds-text>
      </nx-form>
    </template>
  </nx-auth-card>
</template>

<script>
import NxForm from '@/modules/form/Form.vue';
import NxAuthCard from '@/modules/authentication/components/AuthCard.vue';
import NxFormText from '@/modules/form/components/FormText.vue';
import countdown from '@/utils/countdown';
import AuthComponent from '@/modules/authentication/mixins/auth-component';
import { LOGIN_PAGE_ID_LOGIN } from '@/modules/authentication/config/login-routes';

export default {
  name: 'NxAuthForgotPassword',
  components: {
    NxFormText,
    NxAuthCard,
    NxForm,
  },
  mixins: [AuthComponent],
  data() {
    return {
      email: '',
      form: {},
      submitted: false,
      resendEmailCountdown: 0,
      emailAlreadySent: false,
      emailSentAgain: false,
    };
  },
  mounted() {
    if (!this.$store.getters.staffPasswordRecoveryEnabled) {
      this.goToLoginPage();
    }
  },
  methods: {
    async submit() {
      if (this.loading) {
        return;
      }

      if (this.resendEmailCountdown > 0) {
        this.emailAlreadySent = true;
        return;
      }

      try {
        await this.dispatch('authentication/REQUEST_PASSWORD_RECOVERY', { email: this.email });
        this.emailSentAgain = this.submitted;
        this.submitted = true;
        this.initResendEmailCountdown();
      } finally {
        this.emailAlreadySent = false;
        this.loading = false;
      }
    },
    initResendEmailCountdown() {
      countdown(10, ({ remainingTime }) => {
        this.resendEmailCountdown = remainingTime;
      });
    },
    goToLoginPage() {
      this.redirectToLoginPage(LOGIN_PAGE_ID_LOGIN);
    },
  },
};
</script>
